import React from 'react';
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'assets/css/nucleo-icons.css';
import 'assets/scss/blk-design-system-pro-react.scss?v1.2.0';
import ContactMe from 'views/pages/ContactMe.js';
import Error404 from 'views/pages/Error404.js';
import MeetPage from 'views/pages/Meeting.js';

Sentry.init({
  dsn: 'https://9f66ae3566144b11a8cb2f2af4863bf5@o589656.ingest.sentry.io/5739692',
  integrations: [new Integrations.BrowserTracing()],
  denyUrls: ['localhost', '127.0.0.1'],
  tracesSampleRate: 0.2,
  ignoreErrors: [
    'TypeError: Failed to fetch',
    'TypeError: NetworkError when attempting to fetch resource.',
    'TypeError: Cancelled',
  ],
});

class App extends React.Component {

  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/" exact={true} render={(props) => <ContactMe {...props} />} />
          <Route path="/m/:meetingId" render={(props) => <MeetPage {...props} />} />
          <Route path="/error/404" render={(props) => <Error404 {...props} />} />
          <Redirect from="*" to="/" push />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
